/* @flow */

export default class AddCompanyBankAccountRequest {
  companyId: number;
  bankCountryId: number;
  bankIdentifier: string;
  bankAccount: string;
  bankAccountCountryMismatchReason: string;
  isMain: boolean;
}